import itemsAPI from '../../../api/items'
import mediaAPI from '../../../api/media'
import store from '../../../store'
import {upsertRowsRequest, upsertChildrenRequest} from './helpers'

export default {
  async index({commit, rootState}, {isAdmin}) {
    const tenantID = rootState.tenants.current.id
    const topicID = rootState.topics.current.id

    commit('setFetching', true)

    itemsAPI.index({tenantID, topicID}).then(function(resp){
      commit('setIndex', {items: resp.data.data, topicID})

      if (isAdmin) {
        commit('setEditing', topicID)
      }
    }).finally(function(){      
      commit('setFetching', false)
    })
  },

  async update({commit, state, rootState}) {
    const tenantID = rootState.tenants.current.id
    const topicID = rootState.topics.current.id

    commit('setSaving', true)
    commit('setHasApiErrors', false)

    // First we send only the rows so we can get the ids for any new rows. All
    // row children need to reference their parent row during save.
    const rows = {
      items: upsertRowsRequest(state)
    }

    let resp

    try {
      resp = await itemsAPI.update({tenantID, topicID, data: rows})
      commit('updateRowIDs', {items: resp.data.data, topicID})

      // Second we send only the row children since we now have their
      // parent row ids as stored in the db
      const children = {
        items: upsertChildrenRequest(state)
      }

      if (children.items.length) {
        resp = await itemsAPI.update({tenantID, topicID, data: children})
      }

      // if no children were saved, we still fully update the store with the
      // response from the first request
      commit('setIndex', {items: resp.data.data, topicID})
      commit('setEditing', topicID)

    } catch (err) {
      commit('setSaving', false)
      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('setApiErrors', errors)
          commit('setHasApiErrors', true)
        }
      }
    } finally {
      commit('setSaving', false)
    }
  },

  async storeMedia({commit, state, rootState}, {id, data}) {
    const tenantID = rootState.tenants.current.id
    const moduleID = rootState.modules.current.id

    commit('resetFormErrors', id)
    commit('setFormSuccess', {id, value: false})

    const formData = new FormData()
    if (data.name) {
      formData.append('name', data.name)
    }
    if (data.file) {
      formData.append('file', data.file)
    }
    if (data.thumbnail) {
      formData.append('thumbnail', data.thumbnail)
    }

    const moduleData = {'modules': [moduleID]}

    try {
      commit('setFormSaving', {id, value: true})

      let resp = await mediaAPI.store({tenantID, data: formData})
      let media = resp.data.data
      await mediaAPI.relateModules({tenantID, mediaID: media.id, data: moduleData})
      resp = await mediaAPI.show({tenantID, mediaID: media.id})
      media = resp.data.data

      store.commit('media/upsert', media)

      commit('setFormSuccess', {id, value: true})
      commit('resetFormFields', id)
      commit('setProps', {id, props: { media: [media] }})

    } catch (err) {
      commit('setFormSuccess', {id, value: false})

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('setFormErrors', {id, errors})
        }
      }
    } finally {
      commit('setFormSaving', {id, value: false})
    }
  },

  async destroy({commit, state, rootState}, {itemID}) {
    const tenantID = rootState.tenants.current.id
    const topicID = rootState.topics.current.id

    commit('removeItem', itemID)

    try {
      itemsAPI.destroy({tenantID, topicID, itemID})
    } catch (err) {
      // Handled by http client
    }
  },

  async markComplete({commit, rootState}, {itemID}) {
    const tenantID = rootState.tenants.current.id
    const topicID = rootState.topics.current.id

    try {
      itemsAPI.markComplete({tenantID, topicID, itemID})
    } catch (err) {
      // Handled by http client
    }
  },

  async markIncomplete({commit, rootState}, {itemID}) {
    const tenantID = rootState.tenants.current.id
    const topicID = rootState.topics.current.id

    try {
      itemsAPI.markIncomplete({tenantID, topicID, itemID})
    } catch (err) {
      // Handled by http client
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/items/actions.js